var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-operation-historical-history" },
    [
      _c(
        "a",
        {
          staticClass: "green-operation-historical-history__back-link",
          on: {
            click: function ($event) {
              return _vm.$emit("back")
            },
          },
        },
        [
          _vm._v(
            "\n    < " +
              _vm._s(_vm.$t("tenancy.greenOperation.backToSpp")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "HKLCard",
        {
          staticClass: "green-operation-historical-history__card",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "green-operation-historical-history__row-header",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("tenancy.greenOperation.historicalRecords")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("GreenOperationStatusInfo"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row green-operation-historical-history__sections" },
            [
              _vm.hasExcludedDocument
                ? _c(
                    "HKLCard",
                    {
                      class: [
                        "green-operation-historical-history__section-card",
                        _vm.hasHistoricalDetails ? "small-6" : "small-12",
                      ],
                      attrs: {
                        title: _vm.$t(
                          "tenancy.greenOperation.tab.sustainabilityDocuments"
                        ),
                      },
                    },
                    [
                      _c("GreenOperationDocuments", {
                        attrs: { readonly: "", showExcludedOnly: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasHistoricalDetails
                ? _c(
                    "div",
                    {
                      class: [
                        "green-operation-historical-history__details",
                        _vm.hasExcludedDocument ? "small-6" : "small-12",
                      ],
                    },
                    [
                      _vm.showCommentsTab
                        ? _c(
                            "HKLTabs",
                            {
                              staticClass:
                                "shadowline-theme green-operation-historical-history__tabs",
                              attrs: { defaultActiveKey: "1" },
                              model: {
                                value: _vm.activeKey,
                                callback: function ($$v) {
                                  _vm.activeKey = $$v
                                },
                                expression: "activeKey",
                              },
                            },
                            [
                              _c(
                                "a-tab-pane",
                                {
                                  key: "1",
                                  attrs: {
                                    tab: _vm.$t(
                                      "tenancy.greenOperation.tab.assessment"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "HKLCardBody",
                                    [
                                      _c("GreenOperationAssessment", {
                                        attrs: { readonly: "" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-tab-pane",
                                { key: "2" },
                                [
                                  _c("template", { slot: "tab" }, [
                                    _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "tenancy.greenOperation.tab.comments"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "green-operation green-operation-comments",
                                    },
                                    [_c("GreenOperationHistory")],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _c(
                            "HKLCard",
                            {
                              staticClass:
                                "green-operation-historical-history__section-card",
                              attrs: {
                                title: _vm.$t(
                                  "tenancy.greenOperation.tab.assessment"
                                ),
                              },
                            },
                            [
                              _c("GreenOperationAssessment", {
                                attrs: { readonly: "" },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }